import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/style/index.less'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { VueClipboard } from '@soerenmartius/vue3-clipboard'
import JsonViewer from 'vue-json-viewer'
import { createPinia } from 'pinia'
import directives from './directives/index';
import Components from '@/components'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.config.errorHandler = (err, instance, info) => {
  // 处理错误
  console.error('Error Info:', info, '\n', err, '\nInstance:', instance)
}
app.config.warnHandler = (msg, instance, trace) => {
  // 处理错误
  console.warn(`Warn: ${msg.toString()} \nTrace: ${trace}`);
}

app
  .use(createPinia())
  .use(JsonViewer)
  .use(VueClipboard)
  .use(router)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .use(directives)
  .use(Components) // 注册全局组件
router.isReady().then(() => app.mount('#app'))


